export const DEFAULT_VALIDATOR = {
  'mainnet-beta': {
    idPubkey: '3x9nibnhgBHWKMRiGnsXJELRBjviQpKyigfrXtKW27KJ',
    voterKey: '5afRnmkFn1pRU9oussqwk1RRBVyoDgUkL16Jz4qNf574',
  },
  // is random validator for testnet
  'testnet': {
    idPubkey: '75A6FVv8hAZn3n4KsTkURtQP7GDU4SDiZxcTzkTHZM3b',
    voterKey: 'BcX6qjy6fxYSHPyRmy5uJV6Z9MzK8v5ZS8UUiREoEYWW',
  },
}

export const KIWI_VOTE = DEFAULT_VALIDATOR['mainnet-beta'].voterKey
